
import { useState, useEffect } from 'react';

export const useIsCompact = () => {
    const [isCompact, setIsCompact] = useState(false);

    useEffect(() => {
        const checkCompact = () => {
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            const isNarrow = window.innerWidth <= 450;
            // Safari extensions often have smaller popovers, so we treat Safari as compact by default or if narrow
            setIsCompact(isNarrow || isSafari);
        };

        checkCompact();
        window.addEventListener('resize', checkCompact);
        return () => window.removeEventListener('resize', checkCompact);
    }, []);

    return isCompact;
};
